import {mock} from './index';

export default {
  getSecurityMFA: (): void => mock('/security/mfa/get'),
  setSecurityMFA: (): void => mock('/security/mfa/set')
};
